export default {
  isEnv (env: string) {
    return process.env.REACT_APP_ENV === env
  }
}
